export const GetPagination = ({ pagination }) => pagination;
export const GetIndicator = ({ indicator }) => indicator;
